module.exports = __webpack_public_path__ + "img/unverified bank icon.ae5d0649.svg";